<template>
  <div>
    <van-nav-bar class="bg-gradual-blue" title="公告详情" left-text="返回" @click-left="$router.go(-1)" left-arrow />
    
    <div style="padding:5px;">
      <van-cell center :border="hbor" value-class="center_l"> {{notice.title}} </van-cell>
      <van-cell center :border="hbor" value-class="center_s"> 
        <span>发布时间:{{notice.startDate}}  &nbsp;&nbsp;&nbsp;&nbsp; 阅读次数:{{notice.count}} </span>
      </van-cell>
      <div style="padding: 5px 10px;font-size: 16px;background-color: #ffffff;" v-html="notice.content"></div>
    </div>
  </div>
</template>

<script>
import { loadData } from '@/utils/common'

export default {
  data() {
    return {
      notice:{},
      noticeList:[],
      hbor:false,
      iscenter:true
    };
  },
  created(){
    if(this.$route.params.id){
      this.initData(this.$route.params.id);
    }
  },
  methods: {
    initData(id){
      let param = {"id":id};
      loadData('/appIndex/queryNoticeDetail',param).then(response => {
        if(response && response.code == 0){
          this.notice = response.data;
        }
      }).catch(() => {
        //this.listLoading = false
      })
    }
  }
};
</script>

<style>
  .center_l{
    text-align: center;
    font-size: 20px;
  }
  .center_s{
    text-align: center;
  }
</style>
